import React from "react";
import '../../App.css'
import TheVisionAndMissonCard from "../TheVisionAndMissonCard";
import Roots from "../Roots";

export default function TheVisionAndMisson(){
    return (
        <>
            <TheVisionAndMissonCard />
            <Roots />
        </>

    )
}